import { DataState } from "../models/DataState";
import type { KeyValue } from "../models/KeyValue";
import type { Product } from "../models/Product";
import { CreateCrudService } from "./CrudServiceFactory";
import { apiClient } from "../api/ApiClient";
import { BuildFormData } from "../utils/Util";
import { PagedResult } from "../models/PagedResult";
import { SearchParam } from "../models/SearchParam";

export function ProductService() {
  const crudService = CreateCrudService<Product, KeyValue>({
    Route: "product",
    PaginationInPath: true,
    SearchReferences: true,
    EntityName: "Product",
    PartialFields: ["Name", "Code"],
    LoadingMessage: "Loading products...",
    SavingMessage: "Saving product...",
    MapPartial: (value) => ({
      Key: String(value.Code ?? ""),
      Value: String(value.Name ?? ""),
    }),
    SaveRequest: async (data) => {
      const response = await apiClient.post<Product[]>(
        "product/SaveProduct",
        BuildFormData({ product: (data as Product[]).map(({SellingPrice, DefaultSaleUnitCode, ...product}) => ({...product, Code: product.DataState === DataState.New ? "" : product.Code ?? ""})) }, { MaximumFieldCount: 1000 }),
        { busyMessage: "Saving product..." },
      );
      return response.data;
    },
  });
  const GetActivePartial = async (skip = 0, limit = 200): Promise<PagedResult<KeyValue>> => {
    const page = await crudService.Search(skip, limit, {Filters: [{Field: "IsActive", Operator: "EQ", Value: true}]} as SearchParam);
    return {...page, Data: page.Data.map(product => ({Key: product.Code, Value: product.Name, Other: product}))};
  };
  return {
    ...crudService,
    GetActivePartial,
  };
}
